import styled from 'styled-components';
import { animated } from 'react-spring';

export default animated(styled.div.attrs(({ tag }) => ({ className: tag }))`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.2);
  display: grid;
  padding: 0 1rem;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  align-content: start;
  justify-content: center;
  overflow: auto;
`);
